import { wishlistFilters } from "@/theme2/data/wishlist";

export default function WishlistFilters({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {wishlistFilters.map((filter) => {
        const active = value === filter.value;

        return (
          <button
            key={filter.value}
            type="button"
            onClick={() => onChange(filter.value)}
            aria-pressed={active}
            className={`rounded-full border px-4 py-2 text-xs font-bold uppercase transition focus:outline-none focus:ring-2 focus:ring-ring ${
              active
                ? "border-foreground bg-foreground text-background"
                : "border-border bg-white text-muted-foreground hover:text-foreground"
            }`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
